import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import dashboardEn from "./en/dashboardEn";
import masterEn from "./en/masterEn";
import settingsEn from "./en/settings";
import usersEn from "./en/users";
import notificationsEn from "./en/notificationsEn";
import productManagementEn from "./en/productManagementEn";
import inventoryEn from "./en/inventoryEn";
import salesEn from "./en/salesEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...dashboardEn,
            ...masterEn,
            ...settingsEn,
            ...usersEn,
            ...notificationsEn,
            ...productManagementEn,
            ...inventoryEn,
            ...salesEn,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;